import { jsxs, jsx } from 'react/jsx-runtime';

const TourStep = ({
  title,
  description
}) => /* @__PURE__ */ jsxs("div", { className: "text-center", children: [
  /* @__PURE__ */ jsx("h3", { className: "text-h3", children: title }),
  /* @__PURE__ */ jsx("p", { children: description })
] });

export { TourStep };
